import React from "react";
import NotFoundIcon from "../../assets/images/icon/notFoundIcon.svg";

const NotFound = ({ text }) => {
  return (
    <div style={{ margin: "100px 0" }}>
      <img src={NotFoundIcon} width={150} alt="Not Found Icon" />
      <p style={{ color: "#464E5F", fontWeight: 500, fontSize: "18px" }}>
        {text || `ไม่พบข้อมูล`}
      </p>
    </div>
  );
};

export default NotFound;
